// Allowed values for status-like Firestore fields, per collection.
// Source of truth = what Brugo Pro / Brugo Web actually write (Pro vocabulary first),
// followed by older values still present on legacy docs so nothing is lost.
// Used by inline status selects and the bulk editor (pick a value instead of typing it).

export const PLAN_STATUSES = [
  "draft", "sent_to_customer", "change_requested", "accepted", "declined",
  "pending_customer_signature", "pending_pro_signature", "pending_brugo_signature", "active", "cancelled",
];

export const MILESTONE_STATUSES = [
  "locked", "ready_to_pay", "in_progress", "under_review", "customer_approved", "completed", "disputed",
  // legacy values seen on older docs
  "pending", "not_started", "ready_for_review", "approved", "on_hold", "cancelled",
];

export const MILESTONE_PAYMENT_STATUSES = ["unpaid", "link_sent", "paid", "refunded", "pending", "due", "waived"];

export const VISIT_SEVERITIES = ["normal", "critical"];

// Brugo Web reads these exact values (promise_requests/{projectId}.status):
// submitted -> in_review -> payment_pending -> activated (or declined).
export const PROMISE_STATUSES = ["submitted", "in_review", "payment_pending", "activated", "declined"];

export const TICKET_STATUSES = ["open", "in_progress", "awaiting_customer", "resolved", "closed"];
export const PRIORITIES = ["urgent", "high", "normal", "low"];

export const FIELD_ENUMS = {
  milestone_plans: { status: PLAN_STATUSES },
  project_milestones: { status: MILESTONE_STATUSES, payment_status: MILESTONE_PAYMENT_STATUSES },
  project_delays: { status: ["active", "running", "final", "removed"], caused_by: ["customer", "brugo"], category: ["late_payment", "site_not_ready", "customer_unavailable", "material_selection", "scope_change", "approval_pending", "other"] },
  supervisor_visits: { severity: VISIT_SEVERITIES, cc_status: ["open", "in_progress", "resolved"] },
  critical_notifications: { status: ["unread", "read", "resolved"] },
  disputes: { status: ["open", "in_progress", "resolved", "closed"] },
  promise_requests: { status: PROMISE_STATUSES },
  support_conversations: { status: TICKET_STATUSES, priority: PRIORITIES },
  support_tickets: { status: TICKET_STATUSES, priority: PRIORITIES },
  orders: { current_status: ["order_placed", "confirmed", "packed", "shipped", "out_for_delivery", "delivered", "cancelled", "returned"] },
};

export const enumFor = (path, field) => FIELD_ENUMS[String(path).split("/")[0]]?.[field] || null;

// Human labels (shared with Brugo Pro / Brugo Web wording).
export const LABELS = {
  // milestone_plans
  draft: "Draft", sent_to_customer: "Sent to customer", change_requested: "Change requested", accepted: "Accepted",
  declined: "Declined", pending_customer_signature: "Customer to sign", pending_pro_signature: "Pro to sign",
  pending_brugo_signature: "Brugo to sign", active: "Active (all signed)",
  // project_milestones
  locked: "Not started", ready_to_pay: "Ready to pay", in_progress: "In progress", under_review: "Ready for review",
  customer_approved: "Customer approved", completed: "Completed", disputed: "Disputed",
  unpaid: "Unpaid", link_sent: "Link sent", paid: "Paid", refunded: "Refunded",
  // promise
  submitted: "Request submitted", in_review: "In review", payment_pending: "Payment pending", activated: "Promise activated",
  normal: "Normal", critical: "Critical", open: "Open", resolved: "Resolved", closed: "Closed",
  awaiting_customer: "Awaiting customer", urgent: "Urgent", high: "High", low: "Low", unread: "Unread", read: "Read",
};
export const labelOf = (v) => LABELS[v] || String(v ?? "—").replace(/_/g, " ");
